import styled from 'styled-components';
export var StyledHighlighter = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledHighlighter",
  componentId: "c11n-8-111-1__sc-uzdygj-0"
})([""]);